import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import './FindPackage.css';
import PackageFilter from '../../../components/filters/packageFilter/PackageFilter';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faLockOpen } from "@fortawesome/free-solid-svg-icons";
import Grid from "../../../components/grid/Grid";
import { formatToBrowserTime } from '../../../utils/timeFormat';
import { useNavigate } from 'react-router-dom';
import { getPackageInfo } from '../../../services/scm/Package';

export default function FindPackage({ title = 'Find Package', isDeployment = false }) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const headers = [
        { key: "status", label: "Published", width: "10%", alignContent: "center", alignHeader: "center" },
        { key: "packageName", label: "Package Name", width: "30%" },
        { key: "versionName", label: "Version", width: "15%" },
        { key: "description", label: "Description", width: "15%" },
        { key: "expiryDate", label: "Expiration Date", width: "20%" },
        { key: "assetType", label: "Type", width: "10%" },
    ];

    const mapApiResponseToGridData = (dataArray) => {
        return dataArray.map((item, index) => ({
            id: `${index + 1}`,
            packageName: item.packageName || "Unknown Package",
            status: (
                <span style={{ color: item.status === "PUBLISHED" ? "green" : "red" }}>
                    <FontAwesomeIcon icon={item.status === "PUBLISHED" ? faLock : faLockOpen} />
                </span>
            ),
            versionName: item.version || "-",
            description: item.description || "-",
            expiryDate: item.expiration ? (formatToBrowserTime(item.expiration) || item.expiration) : "Never",
            assetType: item.assetType || "-",
        }));
    };

    const loadData = async (searchData) => {
        try {
            setLoading(true);
            const raw = await getPackageInfo(searchData);
            const formatted = Array.isArray(raw) ? raw : [raw];
            const mapped = mapApiResponseToGridData(formatted);
            setData(mapped);
        } catch (err) {
            setError(err.message);
            console.error("Fetch failed:", err);
        } finally {
            setLoading(false);
        }
    };

    const onSearch = (searchData) => {
        loadData(searchData);
    };

    const handleRowClick = (row) => {
        const params = {
            packageName: row.packageName,
            versionName: row.versionName,
        };
        if (isDeployment) {
            navigate('/software-management/create-deployment', { state: params });
        } else {
            navigate('/software-management/package-summary', { state: params });
        }
    };

    return (
        <div className="container my-3 find-package">
            <div className=" col-12 col-xxl-10 responsive-col d-flex flex-column h-100">
                <div className="d-flex justify-content-between align-items-center mb-1">
                    <h5 className="card-title mb-0">{t(title)}</h5>
                </div>

                <div className="filter-wrap">
                    <PackageFilter key={isDeployment ? "deployment" : "normal"} onSearch={onSearch} onReset={onSearch} isDeployment={isDeployment} />
                </div>

                <div className="grid-wrap">
                    <Grid
                        headers={headers}
                        data={data}
                        rowsPerPage={50}
                        canMultiSelect={false}
                        onRowClick={handleRowClick}
                        loading={loading}
                        sortable={true}
                    />
                </div>
            </div>
        </div>
    );
}
